import { useTranslation } from 'react-i18next';

import {
  Modal,
  Form,
  SelectInput,
  ButtonsWrapper,
  Button,
  Loader,
} from '@thinknet-gmbh/platform-common-ui';

import { filterOption } from 'src/common/helpers/common.helpers';
import { IJob } from 'src/pages/jobs/jobs.interfaces';
import { useGetEmployeesWithoutActiveWorkingConditions } from 'src/hooks/employees/get-employees-without-active-working-conditions.hook';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { EMPLOYEE_PAGES } from 'src/pages/employee/employee.constants';
import { EMPLOYEE_DETAILS_TABS } from 'src/pages/employee/sub-pages/employee-details/employee-details-tabs/employee-details.constants';

interface IProps {
  isOpened: boolean;
  onClose: () => void;
  data: { jobLocationId: string; jobSupervisorId: string; job: IJob };
}

const SetJobToEmployeeModal = ({ isOpened, onClose, data }: IProps) => {
  const { t } = useTranslation(['common', 'jobs']);
  const navigate = useNavigate();

  const { jobLocationId, jobSupervisorId, job } = data;

  const { employees, loading } = useGetEmployeesWithoutActiveWorkingConditions();

  const onFinish = (values: any) => {
    const jobLocation = job.jobLocations.find(({ _id }) => _id === jobLocationId);

    navigate(`${ROUTES.employee}?type=${EMPLOYEE_PAGES.employeeProfile}&id=${values.employeeId}`, {
      state: {
        activeTabKey: '2',
        defaultCreatePage: EMPLOYEE_DETAILS_TABS.workingConditions,
        initialData: {
          companyId: job.companyId,
          companyLocationId: jobLocation?.companyLocationId,
          companyBusinessAddressId: jobLocation?.companyBusinessAddressId,
          companyDepartmentId: jobLocation?.companyDepartmentId,
          jobId: job._id,
          jobSupervisorId,
        },
      },
    });
  };

  if (!job) return null;

  if (loading) {
    return <Loader />;
  }

  return (
    <Modal isOpened={isOpened} onClose={onClose} title={t('jobs:labels.setJobToEmployee')}>
      <Form layout="vertical" onFinish={onFinish} initialValues={{ jobId: job._id }}>
        <Form.Item name="jobId" label={t('common:labels.jobTitle')}>
          <SelectInput disabled>
            <SelectInput.Option value={job._id}>{job.title}</SelectInput.Option>
          </SelectInput>
        </Form.Item>
        <Form.Item
          name="employeeId"
          label={t('jobs:labels.employeeName')}
          rules={[{ required: true, message: t('jobs:validation.employeeNameRequired') }]}
        >
          <SelectInput
            placeholder={t('employee:labels.startTyping')}
            showSearch
            filterOption={filterOption}
          >
            {employees.map((employee: any) => (
              <SelectInput.Option key={employee._id} value={employee._id}>
                {employee.profile.displayName}
              </SelectInput.Option>
            ))}
          </SelectInput>
        </Form.Item>
        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default SetJobToEmployeeModal;
